import { AlertTriangle } from "lucide-react"
import { KpiStrip, KpiTile, MoneyText, StatusPill, ErrorState, formatVnd } from "procurement/design"
import { useGetBudgetDashboardOverviewQuery } from "shared/redux/endpoints/procurementV2"
import { pctOf } from "./chartSetup"

const money = (value) => <MoneyText value={value} compact align="left" />

const OverviewKpis = ({ params }) => {
  const { data, isFetching, isError } = useGetBudgetDashboardOverviewQuery(params)
  const o = data?.items?.[0] || {}
  const used = Math.min(100, Math.max(0, Number(o.usedPercentage) || 0))

  if (isError) return <ErrorState text="Couldn't load the budget overview." />

  return (
    <div className="br-overview">
      <KpiStrip>
        <KpiTile label="Total budget" value={isFetching ? "…" : money(o.totalBudget)} />
        <KpiTile label="Committed" value={isFetching ? "…" : money(o.committed)} />
        <KpiTile label="Unpaid" value={isFetching ? "…" : money(o.unpaid)} />
        <KpiTile label="Paid" value={isFetching ? "…" : money(o.paid)} />
        <KpiTile label="Remaining" value={isFetching ? "…" : money(o.remaining)} emphasis />
      </KpiStrip>
      <div className="br-progress">
        <div className="br-progress-head">
          <span>
            Used <MoneyText value={o.usedAmount} compact align="left" /> · {pctOf(o.usedPercentage)}
          </span>
          {Number(o.overPaid) > 0 && (
            <span className="br-overpaid">
              <AlertTriangle size={14} aria-hidden />
              <StatusPill tone="danger" label={`Overpaid ${formatVnd(o.overPaid)}`} />
            </span>
          )}
        </div>
        <div className="br-progress-track" role="progressbar" aria-valuenow={used} aria-valuemin={0} aria-valuemax={100}>
          <span style={{ width: `${used}%` }} />
        </div>
      </div>
    </div>
  )
}

export default OverviewKpis
